import React from 'react'
import { Avatar, Box, IconButton } from '@mui/material'
import TableData from '../../atoms/table/TableData'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import StatusBtn from '../../atoms/status/StatusBtn'
import KebabMenu from '../../dataGrid/KebabMenu'
import { formatCommonAmount } from '../../../util/formatAmount'

export default function Table({
	rows,
	handleClick,
	handleAcceptClick,
	handleRejectClick,
}) {
	const columns = [
		// {
		// 	field: 'name',
		// 	headerName: 'Name',
		// 	flex: 1.5,
		// 	minWidth: 220,
		// 	renderCell: (params) => (
		// <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
		// 	<Avatar src={params.row.image} alt={params.value} />
		// 	{params.value}
		// </div>
		// 	),
		// },
		{
			field: 'kazooName',
			headerName: 'Wedding Name',
			flex: 2.5,
			minWidth: 240,
			renderCell: (params) => (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						height: '100%',
						gap: '5px',
					}}
				>
					<Avatar src={params.row.image} alt={params.value} />
					<p>{params.value}</p>
				</div>
			),
		},
		{
			field: 'startDate',
			headerName: 'Date',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => <p>{params.value.slice(0, 10)}</p>,
		},
		{
			field: 'budget',
			headerName: 'Budget',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => <p>{formatCommonAmount(params?.value)}</p>,
		},
		{
			field: 'guestCount',
			headerName: 'Guests',
			flex: 1,
			minWidth: 100,
		},
		// {
		// 	field: 'status',
		// 	headerName: 'Status',
		// 	flex: 1,
		// 	minWidth: 130,
		// 	renderCell: (params) => {
		// 		const status = params.value
		// 		if (!status) return '-'
		// 		return (
		// 			<StatusBtn
		// 				label={status}
		// 				size="small"
		// 				variant={
		// 					['Completed'].includes(status)
		// 						? 'completed'
		// 						: ['Pending', 'recieved'].includes(status)
		// 							? 'pending'
		// 							: ['In Progress', 'Accepted'].includes(
		// 										status
		// 								  )
		// 								? 'inprogress'
		// 								: [
		// 											'Declined',
		// 											'Rejected',
		// 											'Cancelled',
		// 									  ].includes(status)
		// 									? 'error'
		// 									: 'default'
		// 				}
		// 			/>
		// 		)
		// 	},
		// },
		{
			field: ' ',
			headerName: ' ',
			flex: 0,
			minWidth: 250,
			headerClassName: 'header-column-right',
			sortable: false,
			disableColumnMenu: true,
			renderCell: ({ row }) => (
				<div
					style={{
						display: 'flex',
						gap: '8px',
						alignItems: 'center',
						justifyContent: 'flex-end',
						height: '100%',
					}}
				>
					{row.status === 'recieved' ? (
						<Box sx={{ display: 'flex', gap: '8px' }}>
							<ButtonCustom
								data-cy="reject-wedding"
								variant="destructive"
								size="sm"
								onClick={() => handleRejectClick(row._id)}
							>
								Decline
							</ButtonCustom>
							<ButtonCustom
								data-cy="confirm-wedding"
								variant="approve"
								size="sm"
								onClick={() => handleAcceptClick(row._id)}
							>
								Accept
							</ButtonCustom>
						</Box>
					) : (
						<ButtonCustom
							data-cy="viewdetail"
							variant="outlined"
							size="md"
							onClick={() => handleClick(row._id, row.status)}
						>
							View Detail
						</ButtonCustom>
					)}
				</div>
			),
		},
	]

	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [menuRow, setMenuRow] = React.useState(null)

	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}

	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

	const getRowId = (row) => {
		return row._id
	}

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						getRowId={getRowId}
						rows={rows}
						columns={columns}
						sx={{
							height: 'calc(100dvh - 200px)',
							'@media (max-width: 768px)': {
								height: 'calc(100dvh - 260px)',
							},
						}}
					/>
				</Box>

				<KebabMenu
					anchorEl={menuAnchor}
					open={Boolean(menuAnchor)}
					onClose={closeMenu}
					items={[
						{
							key: 'Edit',
							label: 'Edit',
							icon: <img src="/images/edit-icon.svg" alt="" />,
							onClick: () => console.log('Edit', menuRow),
						},
						{
							key: 'delete',
							label: 'Delete',
							icon: <img src="/images/DeleteModal.svg" alt="" />,
							onClick: () => console.log('Delete', menuRow),
							color: 'error.main',
						},
					]}
				/>
			</Box>
		</div>
	)
}
